module.exports = __webpack_public_path__ + "img/vertical_3_1_8019.fd54427c.png";